export const VIN_PATTERN = /^[A-Z0-9]{17,22}$/;